<template>
  <div v-if="item" class="updates__block-grid-item">
    <div class="grid-container full">
      <header class="grid-x">
        <div class="cell auto">
          <nuxt-link :to="showRoute">
            <img v-if="image" :alt="title" :src="image">
          </nuxt-link>
        </div>
        <div class="cell small-4 cell--date">
          <nuxt-link :to="showRoute">
            <ArticleDate :date="approvalDate" :plain="true" size="small" />
          </nuxt-link>
        </div>
      </header>
      <div class="grid-x">
        <div class="cell small-12 cell--body">
          <nuxt-link class="" :to="showRoute">
            {{ title }}
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ArticleDate from '~/components/frontend/article-date'
  import UpdateEntity from '~/modules/updates/entities/update'

  export default {
    name: 'BlockGridItem',
    components: {
      ArticleDate,
    },
    props: {
      item: {
        default: null,
        type: UpdateEntity,
      },
    },
    computed: {
      approvalDate () {
        return this.$get(this.item, 'approvedAt')
      },
      image () {
        const imagePath = this.$get(this.item, 'image.small', null)

        return this.$get(this.item, 'image.small', null) == null
          ? this.$get(this.item, 'image.smallDefault', null)
          : imagePath
      },
      showRoute () {
        return this.$get(this.item, 'showRoute', { path: '#' })
      },
      title () {
        return this.$get(this.item, 'title', '')
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";
  @import "~foundation-sites/scss/global";

  .updates__block-grid-item {
    header {
      background: $colour-magnolia;
      border-bottom: none;

      .cell--date {
        padding: rem-calc(10 10 0 10);

        /deep/ .article-date {
          color: $colour-link;
          font-weight: 700;
        }
      }
    }

    .cell--body {
      padding-top: 0.5rem;
    }
  }
</style>
